function getTaxId(){
  const taxIdFields = document.querySelectorAll('#tax-id-field');
  const checkoutButtons = document.querySelectorAll('.cheackout-btn');

  if (!taxIdFields.length || !checkoutButtons.length) return;
  
  checkoutButtons.forEach(btn => {
    btn.disabled = true;
    btn.classList.add('btn-disabled');
  });

  taxIdFields.forEach(field => {
    field.addEventListener('input', () => {
      const hasValue = field.value.trim() !== '';
      checkoutButtons.forEach(btn => {
        btn.disabled = !hasValue;
        btn.classList.toggle('btn-disabled', !hasValue);
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  getTaxId();

  setTimeout(() => {
    getTaxId();
  }, 3000);
})


